import { create } from 'zustand';

interface GuessedCountry {
    name: string;
    continent: string;
}

interface GameState {
    guessedCount: number;
    totalCount: number;
    progressPct: number;
    guessedCountries: GuessedCountry[];
    update: (guessedCount: number, totalCount: number, guessedCountries: GuessedCountry[]) => void;
}

export const useGameStore = create<GameState>((set) => ({
    guessedCount: 0,
    totalCount: 0,
    progressPct: 0,
    guessedCountries: [],
    update: (guessedCount, totalCount, guessedCountries) =>
        set({
            guessedCount,
            totalCount,
            progressPct: totalCount > 0 ? Math.round((guessedCount / totalCount) * 100) : 0,
            guessedCountries,
        }),
}));
